import React from 'react';
import { Link } from 'react-router-dom';
import { getFirstAllowedMenu, hasPermission } from '../security/acl';
import { useUI } from '../store/AppContext';
import { menuIdToPath } from './adminRoutes';
import { cx, uiTokens } from '../utils/uiTokens';

/**
 * Route guard — redirects are handled by AdminLocationSync; this blocks render + data hooks.
 */
export default function RequirePermission({ permission, children, title = 'Access denied' }) {
  const { currentUser } = useUI();

  if (hasPermission(currentUser, permission)) {
    return children;
  }

  const fallbackPath = menuIdToPath(getFirstAllowedMenu(currentUser, ['dashboard', 'bookings', 'settings']));

  return (
    <div className={cx(uiTokens.pageWide, 'py-16')}>
      <div className="mx-auto max-w-lg rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-amber-100 text-amber-800">
          <i className="fas fa-lock" aria-hidden />
        </div>
        <h1 className="text-lg font-semibold text-slate-900">{title}</h1>
        <p className="mt-2 text-sm text-slate-600">
          Your role does not include permission for this area. Contact an administrator if you need access.
        </p>
        <Link
          to={fallbackPath}
          className="mt-6 inline-flex items-center gap-2 rounded-xl bg-indigo-600 px-4 py-2.5 text-sm font-medium text-white hover:bg-indigo-700"
        >
          Go to home
        </Link>
      </div>
    </div>
  );
}
